import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.categoryName = ''
      this.top = ''
    }
  }
}
export default searchFrom
